import { TeliaCol, TeliaHeading, TeliaIcon, TeliaLink, TeliaRow } from '@teliads/components/react';
import './MiniParagraphs.scss';

import Heading from 'components/voca/heading/Heading';
import { MiniParagraphsProps } from 'pages/FlexibleSolutionsTemplate/models';

const MiniParagraphs = ({ title, paragraphs, cta }: MiniParagraphsProps) => {
  const chunkArray = <T,>(array: Array<T>, chunkSize: number): Array<Array<T>> => {
    const result: Array<Array<T>> = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };

  const chunkedItems = chunkArray(paragraphs, 3);

  return (
    <>
      {title && (
        <TeliaRow className="third-section__definitions-heading">
          <TeliaCol width={12}>
            <TeliaHeading tag="h3" variant="title-300">
              {title}
            </TeliaHeading>
          </TeliaCol>
        </TeliaRow>
      )}

      <>
        {chunkedItems.map((chunk, rowIndex) => (
          <TeliaRow key={rowIndex} className="third-section__definitions-wrapper">
            {chunk.map((definition) => (
              <TeliaCol
                width={12}
                widthMd={4}
                key={definition.title}
                className="third-section__definitions"
                dataTestid={`${rowIndex}`}
              >
                <article
                  key={definition.title + rowIndex}
                  className="third-section__definitions--content"
                >
                  {definition.title && (
                    <Heading
                      tag="h3"
                      variant="title-200"
                      className="definitions__title"
                      dataTestId="definitions__title"
                    >
                      {definition.title}
                    </Heading>
                  )}
                  <div>{definition.content}</div>
                </article>
              </TeliaCol>
            ))}
          </TeliaRow>
        ))}
      </>
      {cta && (
        <TeliaLink href={cta.url} variant="standalone" className="definitions__cta">
          {cta.text}
          <TeliaIcon name="arrow-right" slot="right" size="sm" />
        </TeliaLink>
      )}
    </>
  );
};

export default MiniParagraphs;
